interface StatCardProps {
  label: string
  value: number | string
  icon?: string
  color?: string
}

export default function StatCard({ label, value, icon, color = 'text-vertex-gold' }: StatCardProps) {
  return (
    <div className="bg-vertex-navy rounded-lg p-4 border border-vertex-surface">
      <div className="flex items-center justify-between mb-2">
        <span className="text-gray-400 text-sm">{label}</span>
        {icon && <span className="text-lg">{icon}</span>}
      </div>
      <div className={`text-2xl font-bold ${color}`}>{value}</div>
    </div>
  )
}
